import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router/index'
import VueFlatPickr from 'vue-flatpickr-component';

// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'flatpickr/dist/flatpickr.css';
import "@/assets/styles/tailwind.css";

createApp(App)
  .use(router)
  .use(createPinia())
  .use(VueFlatPickr, {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    inline: true
  })
  .mount('#app')
